import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgArrowRedo = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 48 48"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    {desc === undefined ? (
      <desc id={descId}>
        {
          "\n    Arrow Redo Outline Streamline Icon: https://streamlinehq.com\n  "
        }
      </desc>
    ) : desc ? (
      <desc id={descId}>{desc}</desc>
    ) : null}
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M45.7108 24 25.8093 5.0031v10.8554c-19.0456 0-23.5201 13.6563-23.5201 27.1384 5.4967-7.0379 10.3579-10.8554 23.5201-10.8554v10.8554z"
    />
  </svg>
);
export default SvgArrowRedo;
